var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#!"},on:{"click":function($event){$event.preventDefault();return _vm.openModal.apply(null, arguments)}}},[_vm._t("default",function(){return [_vm._v("Upload your Photos")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }